import { useRef } from 'react';

import { Text } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

export function CoordinateSystem() {
  const groupRef = useRef<THREE.Group>(null);

  useFrame(({ camera }) => {
    if (groupRef.current) {
      // Position the coordinate system in the bottom-left corner of the viewport
      const x = -window.innerWidth / 2 + 80;
      const y = -window.innerHeight / 2 + 80;

      // Convert screen coordinates to world coordinates
      const vector = new THREE.Vector3(x, y, 0);
      vector.unproject(camera);

      // Calculate the direction from the camera to this point
      const dir = vector.sub(camera.position).normalize();

      // Calculate the distance
      const distance = -camera.position.z / dir.z;

      // Position the coordinate system
      groupRef.current.position.copy(camera.position).add(dir.multiplyScalar(distance * 0.9));

      // Make the coordinate system face the camera
      groupRef.current.quaternion.copy(camera.quaternion);
    }
  });

  return (
    <group ref={groupRef} scale={0.5}>
      {/* Origin point */}
      <mesh position={[0, 0, 0]}>
        <sphereGeometry args={[0.08, 16, 16]} />
        <meshBasicMaterial color="#b3ec49" />
      </mesh>

      {/* X Axis (Green like in the SVG) */}
      <mesh position={[0.5, 0, 0]}>
        <cylinderGeometry args={[0.03, 0.03, 1, 8]} />
        <meshBasicMaterial color="#b3ec49" />
      </mesh>
      <mesh position={[1.1, 0, 0]} rotation={[0, 0, -Math.PI / 2]}>
        <coneGeometry args={[0.08, 0.2, 8]} />
        <meshBasicMaterial color="#b3ec49" />
      </mesh>
      <Text position={[1.3, 0, 0]} color="#b3ec49" fontSize={0.2}>
        X
      </Text>

      {/* Y Axis (Green like in the SVG) */}
      <mesh position={[0, 0.5, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <cylinderGeometry args={[0.03, 0.03, 1, 8]} />
        <meshBasicMaterial color="#b3ec49" />
      </mesh>
      <mesh position={[0, 1.1, 0]}>
        <coneGeometry args={[0.08, 0.2, 8]} />
        <meshBasicMaterial color="#b3ec49" />
      </mesh>
      <Text position={[0, 1.3, 0]} color="#b3ec49" fontSize={0.2}>
        Y
      </Text>

      {/* Z Axis (Green like in the SVG) */}
      <mesh position={[0, 0, 0.5]} rotation={[0, Math.PI / 2, 0]}>
        <cylinderGeometry args={[0.03, 0.03, 1, 8]} />
        <meshBasicMaterial color="#b3ec49" />
      </mesh>
      <mesh position={[0, 0, 1.1]} rotation={[Math.PI / 2, 0, 0]}>
        <coneGeometry args={[0.08, 0.2, 8]} />
        <meshBasicMaterial color="#b3ec49" />
      </mesh>
      <Text position={[0, 0, 1.3]} color="#b3ec49" fontSize={0.2}>
        Z
      </Text>
    </group>
  );
}
